import React from 'react';
import { useSelector } from 'react-redux';
import Tooltip from '@cpg-its/ads.common.tooltip';
import { DividerSection } from '../../../../stories/divider-section';
import { ContentSpacer } from '../../../global/components/layout/generic-content-spacer';
import { summaryStyles } from '../../../global/constants/theme/styles/pages/annual-enrollment/summary-section';
import { getCurrencyFormat } from '../../../global/helpers/format-helpers';
import { WysiwygWithReactLink } from '../../../global/components/wysiwyg-with-react-link';
import { TcsmStates } from '../../../root/tcsm-model';
import { LabelSettingProps } from '../../../global/models/epi-model';
import { tcsmColors } from '../../../global/constants/theme/theme-constants/colors';
import { AnnualEnrollmentProps } from '../../arc/models/arc-epi-props';

interface Props {
	medicalAvailable: boolean;
	medicalDeclined: boolean;
	medicalAmount: number;
	dentalAvailable: boolean;
	dentalDeclined: boolean;
	dentalAmount: number;

	coverageSummaryTitle: string;
	medicalLabel: string;
	dentalLabel: string;
	costSummaryTotalLabel: string;
	monthlyCostLabel: string;
	monthlyCostDescription: string;
	monthlyCostTooltip?: string;
}

export function MyCPGCoverageCostSummary(props: Props) {
	const summaryClasses = summaryStyles();
	const labelSetting = useSelector<TcsmStates, LabelSettingProps>(state => state.epiProps.labelSettingState.epiContent);
	const aeSettings = useSelector<TcsmStates, AnnualEnrollmentProps>(state => state.epiProps.annualEnrollmentSettingsState.epiContent);
	const { medicalAvailable, medicalAmount, medicalDeclined, dentalAvailable, dentalDeclined, dentalAmount, medicalLabel, dentalLabel, costSummaryTotalLabel, coverageSummaryTitle, monthlyCostLabel, monthlyCostDescription, monthlyCostTooltip } = props;

	return (
		<>
			<DividerSection removeDivider>
				<div className={summaryClasses.summarySection}>
					<div className='summary'>
						<h2 className='summary-header'>{coverageSummaryTitle}</h2>
						<ContentSpacer>
							<div className='summary-tooltip'>
								<h4>{monthlyCostLabel}</h4>
								<div className='summary-tooltip-inner'><Tooltip iconColor={tcsmColors.blue} title={monthlyCostTooltip} /></div>
							</div>
							<WysiwygWithReactLink content={monthlyCostDescription} />
						</ContentSpacer>
						{
							medicalAvailable &&
							(
								!medicalDeclined ? (
									<div className='summary-row'>
										<p>{medicalLabel}</p>
										<p>{getCurrencyFormat(medicalAmount)}</p>
									</div>
								) : (
									<>
										<ContentSpacer>
											<div className='summary-decline'>
												<p>{aeSettings?.declineMedicalCoverageMessage}</p>
											</div>
										</ContentSpacer>
									</>
								)
							)


						}
						{
							dentalAvailable &&
							(

								!dentalDeclined ? (
									<div className='summary-row'>
										<p>{dentalLabel}</p>
										<p>{getCurrencyFormat(dentalAmount)}</p>
									</div>
								) : (
									<>
										<ContentSpacer>
											<div className='summary-decline'>
												<p>{aeSettings?.declineDentalCoverageMessage}</p>
											</div>
										</ContentSpacer>
									</>
								)
							)
						}
						<div className='summary-total'>
							<div className='summary-total-row'>
								<p className='h3-styled'>{costSummaryTotalLabel}</p>
								<p className='h3-styled'>{getCurrencyFormat(medicalAmount + dentalAmount, labelSetting, !(dentalDeclined && medicalDeclined))}</p>
							</div>
						</div>
					</div>
				</div>
			</DividerSection>
		</>
	);
}

MyCPGCoverageCostSummary.defaultProps = {
	monthlyCostTooltip: '',
};